import axios from 'axios';
import { ORDER_AS_COD, ORDER_MEALPLAN } from '../../util/urls';

//Action Types
export const CHANGE_DINING_OPTION = 'CHANGE_DINING_OPTION';
export const LOYALITY_DISCOUNT = 'LOYALITY_DISCOUNT';
export const GIFT_CARD_DISCOUNT = 'GIFT_CARD_DISCOUNT';
export const COD_RESPONSE = 'COD_RESPONSE';
export const MEALPLAN_RESPONSE = 'MEALPLAN_RESPONSE';
export const RESET = 'RESET';
export const LOYALITY_CARD_DATA = 'LOYALITY_CARD_DATA';

//Export Actions
export function setLoyalityCardData(object) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: LOYALITY_CARD_DATA,
        data: object,
      });
      resolve();
    });
  };
}

//Export Actions
export function changeDiningOption() {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: CHANGE_DINING_OPTION,
      });
      resolve();
    });
  };
}

export function loyaltyDiscount(data) {
  return {
    type: LOYALITY_DISCOUNT,
    data: data,
  };
}

export function payCOD(orderDetails, tokenId, jwt) {
  let languageid = localStorage.getItem('language') ? localStorage.getItem('language') : '1';
  orderDetails['languageid'] = languageid;
  return dispatch => {
    let languageid = localStorage.getItem('language') ? localStorage.getItem('language') : '1';
    let config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + btoa(jwt),
      },
    };
    return axios
      .post(ORDER_AS_COD + 'tokenId/' + tokenId, orderDetails, config, languageid)
      .then(function(response) {
        return dispatch(payCodResponse(response));
      });
  };
}

export function payMealPlan(orderDetails, tokenId, jwt, callBack) {
  let languageid = localStorage.getItem('language') ? localStorage.getItem('language') : '1';
  orderDetails['languageid'] = languageid;
  return dispatch => {
    let languageid = localStorage.getItem('language') ? localStorage.getItem('language') : '1';
    let config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + btoa(jwt),
      },
    };
    return axios
      .post(
        ORDER_MEALPLAN +
          'tokenId/' +
          tokenId +
          '/dataname/' +
          orderDetails.dataname,
        JSON.stringify(orderDetails),
        config,
        languageid
      )
      .then(function(response) {
        if (callBack) {
          callBack(response);
        }
        dispatch({
          type: MEALPLAN_RESPONSE,
          response: response,
        });
      });
  };
}

export function payCodResponse(res) {
  return {
    type: COD_RESPONSE,
    response: res,
  };
}

export function giftCardDiscount(data) {
  return {
    type: GIFT_CARD_DISCOUNT,
    data: data,
  };
}

export function resetCheckout() {
  return {
    type: RESET,
  };
}



// WEBPACK FOOTER //
// ./src/views/checkout/actions.js